export const stats = [
  { value: '9', label: 'Volumes Complets' },
  { value: '600+', label: 'Pages de Ressources' },
  { value: '300+', label: 'Unités Didactiques' },
  { value: '100%', label: 'Prêt pour la Classe' },
]

export const beforeItems = [
  'Passer vos dimanches à planifier chaque leçon.',
  "Chercher des fiches sur Pinterest ou Google qui ne s'adaptent jamais à votre classe.",
  'Aucune progression claire année après année : vous repartez toujours de zéro.',
  'Devoir créer vous-même les tests et chercher les solutions.',
  "Se sentir frustré parce que la préparation vous enlève le plaisir d'enseigner.",
]

export const afterItems = [
  'Une année entière cartographiée et organisée pour chaque niveau.',
  "Leçons, exercices et fiches prêts à l'impression.",
  'Un curriculum en spirale logique des 6 aux 15 ans.',
  "Un enseignement simple pas à pas, même si vous n'êtes pas un spécialiste.",
  'Évaluations intégrées et corrigés inclus pour économiser des semaines de travail.',
]

export const recognizeItems = [
  "Vous n'avez plus de temps pour planifier des leçons vraiment engageantes.",
  "Vous voyez les élèves s'ennuyer avec les mêmes vieilles activités répétitives.",
  'Gérer des niveaux différents dans la même classe vous semble impossible.',
  'Vous enseignez la musique hors de votre spécialité et vous avez peur de vous tromper.',
]

export type Volume = {
  number: number
  level: string
  title: string
  text: string
}

export const primaryVolumes: Volume[] = [
  {
    number: 1,
    level: 'CP',
    title: 'Exploration des Sons',
    text: 'Le son, le silence et les premiers pas rythmiques.',
  },
  {
    number: 2,
    level: 'CE1',
    title: 'Le Rythme en Mouvement',
    text: 'La pulsation et le corps comme premier instrument.',
  },
  {
    number: 3,
    level: 'CE2',
    title: 'L’Univers des Instruments',
    text: 'Reconnaissance, familles et lecture facilitée.',
  },
  {
    number: 4,
    level: 'CM1',
    title: 'Voyage à travers les Époques',
    text: 'Écoute active et découverte des grands compositeurs.',
  },
  {
    number: 5,
    level: 'CM2',
    title: 'Musiques du Monde',
    text: 'Jazz, électronique, musiques ethniques et chorale.',
  },
]

export const secondaryVolumes: Volume[] = [
  {
    number: 6,
    level: '6ème',
    title: 'Le Langage Musical',
    text: 'Théorie visuelle, solfège complet et analyse.',
  },
  {
    number: 7,
    level: '5ème',
    title: 'Musique et Image',
    text: 'Musique de film, publicité, jeux vidéo et émotions.',
  },
  {
    number: 8,
    level: '4ème',
    title: 'L’Évolution des Styles',
    text: 'Du Rock au Hip-Hop, identité et création numérique.',
  },
  {
    number: 9,
    level: '3ème',
    title: 'Création et Technologie',
    text: 'IA, streaming et préparation complète au DNB (Brevet).',
  },
]

export const bonuses = [
  {
    title: 'Kit « Première Classe Parfaite »',
    text: "Captez l'attention dès les 60 premières secondes et établissez votre autorité avec joie.",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/0851c1c2-48e2-4a81-aeec-b798ecec9d7e.jpg',
  },
  {
    title: 'Le Coffre aux « Cues » Pédagogiques',
    text: "Les mots exacts à utiliser pour expliquer le rythme et l'harmonie pour que tous comprennent du premier coup.",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/ddfda7ee-1054-43f5-8d72-559c4fa2ce4a.jpg',
  },
  {
    title: 'Système « Progrès Visible »',
    text: "Modèles d'auto-évaluation et certificats. Quand les parents voient le progrès, votre valeur double.",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/931a0509-2d07-4f11-8eb8-9f302c8d5d78.jpg',
  },
  {
    title: 'Guide « Classes de Groupe Sans Chaos »',
    text: 'La méthode pour gérer 25 instruments sans perdre le contrôle de la classe.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/0b8b9774-9e2d-43d6-87e4-dbab85ee543a.jpg',
  },
  {
    title: 'Kit « Anti-Annulations et Engagement »',
    text: "Stratégies psychologiques pour motiver les élèves et réduire l'absentéisme.",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/1c1a5415-14c6-4827-8d87-8cd1ac2a1e26.jpg',
  },
]

export const offerRows = [
  { label: 'Pack Musique Prête (9 Volumes)', value: '197€' },
  { label: '5 Bonus Stratégiques', value: '185€' },
]

export const testimonials = [
  {
    quote:
      "C'est exactement ce dont j'avais besoin. La planification annuelle à elle seule vaut le prix. J'ai enfin récupéré mes dimanches.",
    name: 'Sara M.',
    role: 'Enseignante en Primaire',
  },
  {
    quote:
      "Les fiches sont magnifiques et les élèves de collège ne s'ennuient pas. Un matériel de qualité rare.",
    name: 'Giacomo T.',
    role: 'Professeur de Musique',
  },
]

export const faqs = [
  {
    q: 'Dans quel format sont les documents ?',
    a: "Ce sont des PDF haute résolution prêts à imprimer ou à projeter au tableau numérique.",
  },
  {
    q: "Est-ce adapté si je n'ai pas de solides bases musicales ?",
    a: 'Oui, tout est conçu pour guider l’enseignant pas à pas.',
  },
  {
    q: 'Comment vais-je recevoir le matériel ?',
    a: 'Immédiatement après le paiement, par email.',
  },
  {
    q: 'Puis-je l’utiliser sur tablette ?',
    a: 'Oui, les fichiers sont compatibles avec tous les appareils numériques.',
  },
]

export const heroGuarantees = [
  'Téléchargement numérique instantané',
  "PDF prêts pour l'impression",
  'Paiement unique',
]

export const footerLinks = [
  'Conditions Générales',
  'Politique de Confidentialité',
  'Contact',
]
